module.exports = __webpack_public_path__ + "img/automatic-reapply-demo.44e9d46.gif";